import { CalloutBox } from 'components/Docs/CalloutBox';
import PostHogBillableUsageTemplate from "../../../../contents/docs/_snippets/posthog-billable-usage-template.mdx";
import FlagChargeEstimate from "../../../../contents/docs/feature-flags/snippets/flag-charge-estimate.mdx";
import * as React from 'react';
export default {
  CalloutBox,
  PostHogBillableUsageTemplate,
  FlagChargeEstimate,
  React
};